<template>
  <section class="lymphomap_main main_dashboard">
    <div class="lbil_dashboard">
      <div class="row">
        <div class="col-md-12">
          <div class="main_dashboard_profile_avtar dashboard_well" v-if="userDetails">
            <div class="profile_avtar_img">
              <template v-if="userDetails.thumbnail">
                <div class="prfl_avatar_lazy_load_box">
                  <img :src="userDetails.thumbnail" class="img-fluid">
                  <img :src="userDetails.avatar" v-if="userDetails.avatar" class="img-fluid">
                </div>
              </template>
              <template v-else>
                <img src="@/assets/images/user_default.png" class="img-fluid">
              </template>
            </div>
            <div class="profile_details">
              <div class="user_info_name" v-if="userDetails">Dr
                {{ userDetails.first_name }}
                {{ userDetails.last_name }}
              </div>
              <div class="personal_user_d_country">{{ userDetails.profile.city }}, India
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-3">
          <div class="dashboard_filters_list">
            <carousel :mouseDrag="false" :touchDrag="false" :autoplay="false" :loop="false" :nav="false"  :margin="15" :dots="false" :items="4" :responsive="{0:{items:1}, 1024:{items:4}, 1900:{items:6}}"  v-once>
              <template slot="prev"><span class="all_users_slider_arrow member_slider_prev"><i class="fa fa-angle-left" aria-hidden="true"></i></span></template>
              <div class="carousel_item">
                <div class="total_count_box active" @click="dashboardFiltersAction('active_doctors')"
                  id="filter_active_doctors">
                  <div class="count_icon">
                    <span class="filter_cat_img_box">
                      <img src="@/assets/images/filter_icon/doctor.png" class="img-fluid" style="width:35px;">
                    </span>
                  </div>
                  <div class="count_title_w_n">
                    <span class="count_title">
                      <div class="global_filter_name_in_html">Active Doctors</div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="carousel_item">
                <div class="total_count_box" @click="dashboardFiltersAction('requested_doctors')"
                id="filter_requested_doctors">
                  <div class="count_icon">
                    <span class="filter_cat_img_box">
                      <i class="fa fa-laptop" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div class="count_title_w_n">
                    <span class="count_title">
                      <div class="global_filter_name_in_html">Doctors Requests</div>
                    </span>
                  </div>
                </div>
              </div>
              <div class="carousel_item">
                <router-link :to="{ name: 'lbilAdminNgoList'}">
                  <div class="total_count_box">
                      <div class="count_icon">
                        <span class="filter_cat_img_box">
                          <img src="@/assets/images/filter_icon/ngo.png" class="img-fluid" style="width:48px;">
                        </span>
                      </div>
                      <div class="count_title_w_n">
                        <span class="count_title">
                          <div class="global_filter_name_in_html">NGOs</div>
                        </span>
                      </div>
                  </div>
              </router-link>
              </div>
              <div class="carousel_item">
                <router-link :to="{ name: 'lbilAdminListSGList'}">
                  <div class="total_count_box">
                      <div class="count_icon">
                        <span class="filter_cat_img_box">
                          <img src="@/assets/images/filter_icon/sg.png" class="img-fluid" style="width:48px;">
                        </span>
                      </div>
                      <div class="count_title_w_n">
                        <span class="count_title">
                          <div class="global_filter_name_in_html">Support Groups</div>
                        </span>
                      </div>
                    </div>
                  </router-link>
              </div>
              <div class="carousel_item">
                  <div class="total_count_box" @click="dashboardFiltersAction('lbil_users')"
                  id="filter_lbil_users">
                    <div class="count_icon">
                      <span class="filter_cat_img_box">
                        <img src="@/assets/images/filter_icon/new_user.png" class="img-fluid" style="width:45px;">
                      </span>
                    </div>
                    <div class="count_title_w_n">
                      <span class="count_title">
                        <div class="global_filter_name_in_html">LBIL Users</div>
                      </span>
                    </div>
                  </div>
              </div>
              <template slot="next"><span class="all_users_slider_arrow member_slider_next"><i class="fa fa-angle-right" aria-hidden="true"></i></span></template>
            </carousel>
          </div>
          <!-- <div class="dashboard_filters_list">
            <div class="row">
              <div class="col-sm-3">
                <div class="total_count_box" @click="dashboardFiltersAction('active_doctors')"
                  :class="dashboardFiltersState == 'active_doctors' ? 'active' : ''">
                  <div class="count_icon"><span>
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                        <g>
                          <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                              <path
                                d="M467,0H45C20.186,0,0,20.186,0,45v76h512V45C512,20.186,491.814,0,467,0z M75,90c-8.284,0-15-6.716-15-15    c0-8.286,6.716-15,15-15s15,6.714,15,15C90,83.284,83.284,90,75,90z M135,90c-8.284,0-15-6.716-15-15c0-8.286,6.716-15,15-15    s15,6.714,15,15C150,83.284,143.284,90,135,90z M195,90c-8.284,0-15-6.716-15-15c0-8.286,6.716-15,15-15s15,6.714,15,15    C210,83.284,203.284,90,195,90z"
                                fill="#ffc107" data-original="#000000" style="" class="" />
                            </g>
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                              <path
                                d="M0,151v316c0,24.814,20.186,45,45,45h422c24.814,0,45-20.186,45-45V151H0z M60,197c0-8.291,6.709-15,15-15h150    c8.291,0,15,6.709,15,15v120c0,8.291-6.709,15-15,15H75c-8.291,0-15-6.709-15-15V197z M437,452H75c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h362c8.291,0,15,6.709,15,15C452,445.291,445.291,452,437,452z M437,392H75c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h362c8.291,0,15,6.709,15,15C452,385.291,445.291,392,437,392z M437,332H285c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h152c8.291,0,15,6.709,15,15C452,325.291,445.291,332,437,332z M437,272H285c-8.291,0-15-6.709-15-15    c0-8.291,6.709-15,15-15h152c8.291,0,15,6.709,15,15S445.291,272,437,272z"
                                fill="#ffc107" data-original="#000000" style="" class="" />
                            </g>
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                            <g>
                              <rect x="90" y="212" width="120" height="90" fill="#ffc107" data-original="#000000"
                                style="" class="" />
                            </g>
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                        </g>
                      </svg>
                    </span></div>
                  <div class="count_title_w_n">
                    <span class="count_title">Active Doctors</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="total_count_box" @click="dashboardFiltersAction('requested_doctors')"
                  :class="dashboardFiltersState == 'requested_doctors' ? 'active' : ''">
                  <div class="count_icon">
                    <span>
                      <i class="fa fa-laptop" aria-hidden="true"></i>
                    </span>
                  </div>
                  <div class="count_title_w_n">
                    <span class="count_title">Doctors Requests</span>
                  </div>
                </div>
              </div>
              <div class="col-sm-3">
                  <div class="total_count_box" @click="dashboardFiltersAction('lbil_users')"
                  :class="dashboardFiltersState == 'lbil_users' ? 'active' : ''">
                    <div class="count_icon"><span>
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                          xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                          viewBox="0 0 24 24" style="enable-background:new 0 0 512 512" xml:space="preserve">
                          <g>
                            <path xmlns="http://www.w3.org/2000/svg"
                              d="m15.25 24h-14.5c-.414 0-.75-.336-.75-.75v-3.5c0-2.067 1.683-3.75 3.75-3.75h8.5c2.067 0 3.75 1.683 3.75 3.75v3.5c0 .414-.336.75-.75.75z"
                              fill="#ffc107" data-original="#000000" style="" />
                            <path xmlns="http://www.w3.org/2000/svg"
                              d="m8 4c-3.033 0-5.5 2.467-5.5 5.5v2.75c0 .965.785 1.75 1.75 1.75h3.75c-1.937 0-3.5-1.563-3.5-3.5 2.333 0 3.5-1.75 3.5-3.5 0 1.75 1.167 3.5 3.5 3.5 0 1.937-1.563 3.5-3.5 3.5h3.75c.965 0 1.75-.785 1.75-1.75v-2.75c0-3.033-2.467-5.5-5.5-5.5z"
                              fill="#ffc107" data-original="#000000" style="" />
                            <path xmlns="http://www.w3.org/2000/svg"
                              d="m22.25 0h-5.5c-.965 0-1.75.785-1.75 1.75v4.75c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5v-4.75c0-.965-.785-1.75-1.75-1.75zm-1 5.75h-1v1c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1h-1c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h1v-1c0-.414.336-.75.75-.75s.75.336.75.75v1h1c.414 0 .75.336.75.75s-.336.75-.75.75z"
                              fill="#ffc107" data-original="#000000" style="" />
                            <path xmlns="http://www.w3.org/2000/svg"
                              d="m17.5 21h-2.25c-.553 0-1-.447-1-1s.447-1 1-1h2.25c.552 0 1-.448 1-1v-7.5c0-.552.447-1 1-1s1 .448 1 1v7.5c0 1.654-1.346 3-3 3z"
                              fill="#ffc107" data-original="#000000" style="" />
                          </g>
                        </svg>
                      </span></div>
                    <div class="count_title_w_n">
                      <span class="count_title">LBIL Users</span>
                    </div>
                  </div>
              </div>
              <div class="col-sm-3">
                <div class="total_count_box awerack_tab" @click="dashboardFiltersAction('ngo_sg')"
                :class="dashboardFiltersState == 'ngo_sg' ? 'active' : ''">
                  <div class="count_icon"><span>
                      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="30" height="30" x="0" y="0"
                        viewBox="0 0 247 247" style="enable-background:new 0 0 512 512" xml:space="preserve" class="">
                        <g>
                          <path xmlns="http://www.w3.org/2000/svg"
                            d="M171.333,48c-4.143,0-7.833-3.357-7.833-7.5V0H41.333C37.19,0,33.5,3.357,33.5,7.5v231c0,4.133,3.51,7.737,7.644,7.75  L206.311,247c0.008,0,0.015,0,0.015,0c1.993,0,3.731-1.037,5.136-2.438c1.412-1.407,2.039-3.568,2.039-5.562V48H171.333z   M171.833,181h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,181,171.833,181z   M171.833,148h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,148,171.833,148z   M171.833,115h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,115,171.833,115z   M171.833,84h-99c-4.143,0-7.5-3.357-7.5-7.5s3.357-7.5,7.5-7.5h99c4.143,0,7.5,3.357,7.5,7.5S175.976,84,171.833,84z M210.767,33  H178.5V2.383L210.767,33z"
                            fill="#ffc107" data-original="#000000" style="" class="" />
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                          <g xmlns="http://www.w3.org/2000/svg">
                          </g>
                        </g>
                      </svg>
                    </span>
                  </div>
                  <div class="count_title_w_n">
                    <span class="count_title">NGOs and Support Groups</span>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
          <div class="main_dashboard_updates dashboard_well">
            <div class="top_brd" v-if="dashboardFiltersState == 'active_doctors'">
              <table class="table" v-if="doctorActvList">
                <thead>
                  <tr>
                    <th width="20%">Name</th>
                    <th width="15%" class="text-center">Reg. Number</th>
                    <th width="15%" class="text-center">Country</th>
                    <th width="20%" class="text-center">Hospital</th>
                    <th width="15%" class="text-center">Department</th>
                    <th width="10%" class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="doctorActvListResults.length > 0">
                  <tr v-for="item in doctorActvListResults" :key="item.id">
                    <td>
                      <span class="member_user_avtaar">
                        <span>
                          <img v-if="item.profile.thumbnail" :src="item.profile.thumbnail" alt="" width="50">
                          <img src="@/assets/images/user2.png"
                            v-bind:class="item.profile.thumbnail ? 'd-none' : ''" alt="" width="50">
                        </span>
                      </span>
                      <span class="member_user_info">
                        <span class="member_user_name">
                          Dr {{ item.first_name }} {{ item.last_name }}
                        </span>
                        <span class="member_user_email">{{ item.email }}</span>
                      </span>
                    </td>
                    <td class="text-center">
                      <div class="dctr_slctd_cat">
                        <span class="dctr_reg_num">Reg.#: {{item.license_value}}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <template v-if="item.profile.country">
                        <img :src="getCountryFlag(item.profile.country, 'flag')" class="country-flag" />
                        <span class="text-capitalize">{{ getCountryFlag(item.profile.country, 'name') }}</span>
                      </template>
                      <template v-else>
                        <img :src="getCountryFlag('in', 'flag')" class="country-flag" />
                        India
                      </template>
                    </td>
                    <td class="text-center">{{ item.organization }}
                    </td>
                    <td class="text-center">
                      <template v-if="item.profile.professional_filter_name">{{ item.profile.professional_filter_name }}</template>
                      <template v-else>-</template>
                    </td>
                    <td>
                      <ul class="action_list">
                        <li><button class="btn btn-info" v-on:click="consultDoctorInfoPopupShowMethod(item)"><i
                              class="fa fa-eye"></i></button></li>
                        <li>
                          <button class="btn btn-danger"
                            @click="consultRequestCancelPopupMethod(item.id)">Deactivate</button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center pt-4">No Data Available</td>
                  </tr>
                </tbody>
              </table>
              <div class="fixloader userLoading" v-else>
                <div class="spinner spinner-1"></div>
              </div>
            </div>
            <div class="top_brd" v-if="dashboardFiltersState == 'requested_doctors'">
              <table class="table" v-if="doctorReqList">
                <thead>
                  <tr>
                    <th width="20%">Name</th>
                    <th width="15%" class="text-center">Reg. Number</th>
                    <th width="15%" class="text-center">Country</th>
                    <th width="20%" class="text-center">Hospital</th>
                    <th width="15%" class="text-center">Department</th>
                    <th width="10%" class="text-right">Action</th>
                  </tr>
                </thead>
                <tbody v-if="doctorReqListResults.length > 0">
                  <tr v-for="item in doctorReqListResults" :key="item.id">
                    <td>
                      <span class="member_user_avtaar">
                        <span>
                          <img v-if="item.profile.thumbnail" :src="item.profile.thumbnail" alt="" width="50">
                          <img src="@/assets/images/user2.png"
                            v-bind:class="item.profile.thumbnail ? 'd-none' : ''" alt="" width="50">
                        </span>
                      </span>
                      <span class="member_user_info">
                        <span class="member_user_name">
                          Dr {{ item.first_name }} {{ item.last_name }}
                        </span>
                        <span class="member_user_email">{{ item.email }}</span>
                      </span>
                    </td>
                    <td class="text-center">
                      <div class="dctr_slctd_cat">
                        <span class="dctr_reg_num">Reg.#: {{item.license_value}}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <template v-if="item.profile.country">
                        <img :src="getCountryFlag(item.profile.country, 'flag')" class="country-flag" />
                        <span class="text-capitalize">{{ getCountryFlag(item.profile.country, 'name') }}</span>
                      </template>
                      <template v-else>
                        <img :src="getCountryFlag('in', 'flag')" class="country-flag" />
                        India
                      </template>
                    </td>
                    <td class="text-center">{{ item.organization }}
                    </td>
                    <td class="text-center">
                      <template v-if="item.profile.professional_filter_name">{{ item.profile.professional_filter_name }}</template>
                      <template v-else>-</template>
                    </td>
                    <td>
                      <ul class="action_list">
                        <li><button class="btn btn-info" v-on:click="requestUserInfoPopupShowMethod(item)"><i
                              class="fa fa-eye"></i></button></li>
                        <li>
                          <button class="btn btn-success"
                            @click="consultRequestPopupMethod(item.id)">Approve</button>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center pt-4">No Data Available</td>
                  </tr>
                </tbody>
              </table>
              <div class="fixloader userLoading" v-else>
                <div class="spinner spinner-1"></div>
              </div>
            </div>
            <div class="top_brd" v-if="dashboardFiltersState == 'lbil_users'">
              <allUserList></allUserList>
            </div>
            <div class="top_brd" v-if="dashboardFiltersState == 'ngo_sg'">
              <h4 class="coming_soon text-center">Coming Soon</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <doctorReqApprovePopup :consultRequestId="consultRequestId" v-if="confrimConsultRequestPopupState"></doctorReqApprovePopup>
    <doctorReqCancelPopup :consultRequestId="consultRequestId" v-if="cancelConsultRequestPopupState"></doctorReqCancelPopup>
    <doctorInfoPopup :consultDoctorInfoPopupData="consultDoctorInfoPopupData" v-if="consultDoctorInfoPopupState"></doctorInfoPopup>
    <requestUserInfoPopup :consultDoctorInfoPopupData="consultDoctorInfoPopupData" v-if="requestUserInfoPopupState"></requestUserInfoPopup>
  </section>
</template>


<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery'); 
import carousel from 'vue-owl-carousel';
import {bus} from '@/main';
import countries from '@/services/country.json'
import { mapGetters } from 'vuex';
import doctorReqApprovePopup from '@/components/lbil/doctor-consult-req-approve-popup/'
import doctorReqCancelPopup from '@/components/lbil/doctor-req-cancelled-popup/'
import doctorInfoPopup from '@/components/lbil/lbil-doctor-info-popup/'
import requestUserInfoPopup from '@/components/lbil/lbil-doctor-info-popup/requestUserInfo.vue'
import allUserList from '@/components/lbil/all-users-list'

export default {
  name: 'lbil-dashboard',
  components: {
    doctorReqApprovePopup,
    doctorReqCancelPopup,
    doctorInfoPopup,
    requestUserInfoPopup,
    allUserList,
    carousel
  },
  props: [],
  data() {
    return {
      userDetails: null,
      dashboardFiltersState: 'active_doctors',
      doctorActvList: null,
      doctorActvListResults: [],
      doctorReqList: null,
      doctorReqListResults: [],
      countryList:[],
      confrimConsultRequestPopupState:false,
      consultRequestId:'',
      cancelConsultRequestPopupState:false,
      consultDoctorInfoPopupData:null,
      consultDoctorInfoPopupState:false,
      requestUserInfoPopupState:false
    }
  },
  computed: {
    ...mapGetters(['lbilSuUserDetailGetters']),
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.lbilSuUserDetailGetters.data
    },
  },
  mounted() {
    this.getUserDetailsAgainFun;
    this.doctorActvListMethod();
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    bus.$on('confrimConsultRequestPopupStateBus', (data) => {
      this.confrimConsultRequestPopupState = data;
      this.doctorReqListMethod();
    });
    bus.$on('cancelConsultRequestPopupStateBus', (data) => {
      this.cancelConsultRequestPopupState = data;
      this.doctorActvListMethod();
    });
    bus.$on('consultDoctorInfoPopupStateBus', (data) => {
      this.consultDoctorInfoPopupState = data;
    });
    bus.$on('requestUserInfoPopupStateBus', (data) => {
      this.requestUserInfoPopupState = data;
    });
  },
  methods: {
    requestUserInfoPopupShowMethod(data){
      this.requestUserInfoPopupState = true;
      this.consultDoctorInfoPopupData = data;
      document.body.classList.add('body_right_scroll_remove');
    },
    doctorActvListMethod(){
      this.$store.dispatch('lbilDoctorsListAction').then((res) => {
        this.doctorActvList = res.data.data;
        this.doctorActvListResults = this.doctorActvList.results;
      })
    },
    doctorReqListMethod(){
      this.$store.dispatch('doctorConsultReqLisAction').then((res) => {
        this.doctorReqList = res.data.data;
        this.doctorReqListResults = this.doctorReqList.results || [];
      })
    },
    consultDoctorInfoPopupShowMethod(data){
      this.consultDoctorInfoPopupState = true;
      this.consultDoctorInfoPopupData = data;
      document.body.classList.add('body_right_scroll_remove')
    },
    consultRequestCancelPopupMethod(id){
      this.consultRequestId = id;
      document.body.classList.add('body_right_scroll_remove')
      this.cancelConsultRequestPopupState = true;
    },
    consultRequestPopupMethod(id){
      this.consultRequestId = id;
      document.body.classList.add('body_right_scroll_remove')
      this.confrimConsultRequestPopupState = true;
    },
    dashboardFiltersAction(evt) {
      this.dashboardFiltersState = evt;
      if(this.dashboardFiltersState == 'requested_doctors'){
        this.doctorReqListMethod();
      }else if(this.dashboardFiltersState == 'active_doctors'){
        this.doctorActvListMethod();
      }
      $('.total_count_box').removeClass('active')
      $('#filter_' + evt).addClass('active')
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
  },
  watch: {
    getUserDetailsAgainFun() {
      return this.$store.getters.lbilSuUserDetailGetters
    },
  },
  beforeRouteLeave: function (to, from, next) {
    document.body.classList.remove('body_right_scroll_remove')
    next();
  },
}
</script>
<style lang="scss" scoped>
.main_dashboard {
  font-family: 'MyriadProRegular', 'Lato', sans-serif;
  letter-spacing: 0.5px;
  color: #ffffff;

  .dashboard_well {
    padding: 15px 10px;
    position: relative;
    background: rgba(0, 0, 0, .75);
    -webkit-box-shadow: -5px 5px 10px rgba(138, 145, 153, .06);
    box-shadow: -5px 5px 10px rgba(138, 145, 153, .06);
    border-radius: 5px;
    margin-bottom: 0px;

    .info_ab_tab_contnent {
      padding: 0px 10px;
    }
  }

  .user_info_label {
    display: flex;
    align-items: center;
    font-size: 18px;
    margin-bottom: 15px;
    // transition:all ease 0.5s;
    // -webkit-transition:all ease 0.5s;
    // -moz-transition:all ease 0.5s;
  }

  .user_info_label_key {
    width: 45px;
    flex: 0 0 45px;
    color: #ffd700;
    font-size: 18px;

    &.label_line_break {
      align-self: flex-start;
      margin-top: 3px;
    }
  }

  .main_dashboard_updates {

    // width: 260px;
    h3 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }

  .main_dashboard_tabs {
    padding: 0 10px 15px;

    .nav-tabs {
      border-bottom: none;
      display: flex;
      flex-wrap: wrap;

      .nav-item {
        flex-grow: 1;

        &:nth-child(2) {
          padding: 0 30px;
        }

        @media only screen and (max-width:767px) {
          &:nth-child(2) {
            padding: 0 8px !important;
          }
        }
      }
    }

    .nav-link {
      padding: 6px 25px;
      border: none;
      margin-right: 0px;
      border-radius: 50px !important;
      background: hsla(0, 0%, 100%, .12);
      color: #ffd400;
      margin-bottom: 5px;
      display: inline-block;
      height: auto;
      border: none !important;
      font-size: 18px;
      transition: all ease 0.5s;
      -webkit-transition: all ease 0.5s;
      -moz-transition: all ease 0.5s;
      display: block;
      text-align: center;

      &:hover {
        background: #87cefa;
        color: #22292f;
      }
    }

    .nav-item:last-child .nav-link {
      margin-right: 0px;
    }

    .nav-link.active {
      background: #87cefa;
      color: #22292f;
    }
  }

  .main_dashboard_profile_avtar {
    display: flex;
    min-height: 210px;
    align-items: center;
  }

  .profile_avtar_img {
    max-width: 180px;
    width: 100%;

    @media only screen and(max-width:767px) {
      max-width: 130px;
    }
  }

  .profile_details {
    margin-left: 15px;
    text-align: left;

    @media only screen and(max-width:767px) {
      margin-left: 10px;
    }
  }

  .user_info_name {
    font-size: 20px;
    margin-bottom: 0px;
    transition: all ease 0.5s;
    -webkit-transition: all ease 0.5s;
    -moz-transition: all ease 0.5s;
    line-height: 1.2;
  }

  .main_dashboard_updates.dashboard_well {
    min-height: calc(100dvh - 420px);
  }

  .edit_profile {
    position: absolute;
    top: 5px;
    right: 5px;

    .fa {
      font-size: 24px;
      color: #ffffff;

      &:hover {
        color: #ffd400;
      }
    }
  }

  .edit_profile img {
    cursor: pointer;
    transition: all ease 0.5s;
    -webkit-transition: all ease 0.5s;
    -moz-transition: all ease 0.5s;
  }

  .profile_avtar_img .img-fluid {
    width: 175px;
  }

  .prfl_avatar_lazy_load_box {
    position: relative;
    width: 175px;
    min-height: 175px;
    overflow: hidden;

    @media only screen and (max-width:767px) {
      width: 125px;
      min-height: 125px;
    }

    .img-fluid {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      transform: scale(1);
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      transition: transform ease 0.5s;
      -webkit-transition: transform ease 0.5s;
      -moz-transition: transform ease 0.5s;
      -webkit-backface-visibility: hidden;
      /* Safari */
      backface-visibility: hidden;
    }

    &:hover .img-fluid {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
    }
  }

  .user_info_label_value {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
    font-size: 18px;
    word-break: break-word;
    color: #d6d6d6;
  }

  .bio_read_more_btn {
    color: #87cefa;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: #ffd400;
    }
  }

  .dashboard_filters_list {
    padding: 0px 0 5px;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    position: relative;
    .all_users_slider_arrow {
      position: absolute;
      z-index: 1000;
      top: 50%;
      left:-21px;
      transform: translateY(-50%);
      -webkit-transform: translateY(-50%);
      -moz-transform: translateY(-50%);
      .fa{cursor: pointer;
          font-size: 42px;
          line-height: 28px;
          color: #ffc107;
          &:hover{color: #87cefa;}
      }
      &.member_slider_next{
          right: -21px;
          left: auto;
      }
      }   
    .total_count_box {
      background: rgba(255, 255, 255, 0.1);
      padding: 0px 20px;
      border-radius: 3px;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      cursor: pointer;
      color: #fff;
      height: 115px;
      box-shadow: 3px 3px 3px rgba(138, 145, 153, 0.1), -3px -3px 3px rgba(138, 145, 153, 0.1);

      &:hover {
        background: #87cefa;
        color: #000000;
        .img-fluid{
          filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
          -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
        }
      }

      &:hover .count_icon rect {
        fill: #000000;
      }

      &:hover .count_icon path {
        fill: #000000;
      }

      &:hover .count_icon circle {
        fill: #000000
      }

      &:hover .count_icon span {
        background: rgba(0, 0, 0, 0.1)
      }

      &.active {
        background: #87cefa;
        color: #000000;
        .img-fluid{
          filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
          -webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(100deg) brightness(0%) contrast(100%);
        }
      }

      &.active .count_icon rect {
        fill: #000000;
      }

      &.active .count_icon path {
        fill: #000000;
      }

      &.active .count_icon span {
        background: rgba(255, 255, 255, 0.15);
      }

      .hover_txt {
        display: none;
      }

      &.awerack_tab:hover .hover_txt,
      &.awerack_tab.active .hover_txt {
        display: block;
      }

      &.awerack_tab:hover .normal_txt,
      &.awerack_tab.active .normal_txt {
        display: none;
      }

      .fa-laptop {
        font-size: 40px;
        line-height: 70px;
        color: #ffc107;
      }

      &:hover .fa-laptop,
      &.active .fa-laptop {
        color: #000000;
      }
    }

    .count_icon span {
      width: 70px;
      display: inline-block;
      height: 70px;
      background: hsla(0, 0%, 100%, .1);
      border-radius: 50%;
      text-align: center;
      line-height: 70px;
      .img-fluid{display:inline-block}
    }

    .count_title_w_n {
      padding-left: 8px;
    }

    .count_number {
      display: block;
      font-size: 22px;
      font-weight: 600;
      transition: all ease 0.5s;
      -webkit-transition: all ease 0.5s;
      -moz-transition: all ease 0.5s;
    }

    .count_title {
      font-size: 18px;
      text-transform: capitalize;
      line-height: 1;
      // transition:all ease 0.5s;
      // -webkit-transition:all ease 0.5s;
      // -moz-transition:all ease 0.5s;
    }

    .row .col-sm-3 {
      padding-left: 5px;
      padding-right: 5px;
    }

    .row {
      margin-left: -5px;
      margin-right: -5px;
    }
  }

  .table {
    margin-bottom: 0;
    letter-spacing: 0.5px;
    color: #ffffff;
    border-collapse: separate;
    border-spacing: 0 3px;

    thead th {
      border-bottom: 0;
      font-size: 19px;
      padding: 10px 8px;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      text-transform: uppercase;
      border-top: 0px;
      transition: all ease 0.5s;
      -webkit-transition: all ease 0.5s;
      -moz-transition: all ease 0.5s;
      background: rgba(228, 233, 237, .1);
      color: #87cefa;
    }

    thead .empty_cell th {
      padding: 0px !important;
      background: none !important;
    }

    tbody td {
      color: #ffffff;
      vertical-align: middle;
      padding: 10px 8px;
      font-size: 20px;
      font-family: 'MyriadProRegular', 'Lato', sans-serif;
      transition: all ease 0.5s;
      -webkit-transition: all ease 0.5s;
      -moz-transition: all ease 0.5s;
      height: 120px;
      border-top: 0px;
      background: rgba(228, 233, 237, .1);
    }

    a:hover {
      text-decoration: none;
    }

    .member_user_avtaar {
      display: inline-block;
      vertical-align: middle;
      position: relative;

      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        cursor: pointer;
      }
    }

    .online-status {
      position: absolute;
      right: 4px;
      bottom: 2px;
      border: 1px solid #9E9E9E;
      border-radius: 50%;
      width: 12px;
      height: 12px;
      background: #9E9E9E;

      &.online {
        background-color: #4CAF50;
        border-color: #4CAF50;
      }

      &.busy {
        background-color: #F44336;
        border-color: #F44336;
      }
    }

    .member_user_info {
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 70px);
      margin-left: 10px;
    }

    .member_user_name {
      line-height: 1;
      font-size: 20px;
      color: #fff;
      display: block;
      cursor: pointer;
      text-transform: capitalize;
      transition: all ease 0.5s;
      -webkit-transition: all ease 0.5s;
      -moz-transition: all ease 0.5s;

      a {
        color: #ffffff;
        text-decoration: none;
        text-transform: capitalize;

        &:hover {
          color: #ffd400;
        }
      }
    }

    .member_join_date {
      line-height: 1;
      font-size: 16px;
      color: #fff;
      display: block;
    }

    .member_user_email,
    .member_join_time {
      font-size: 15px;
      color: hsla(0, 0%, 100%, .5);
      white-space: pre-wrap;
      word-break: break-all;
      display: block;
    }

    .country-flag {
      width: 50px;
      display: inline-block;
      vertical-align: middle;
      margin-right: 5px;
      // height: 64px;
      object-fit: cover;
    }

    .country-flag-name {
      width: calc(100% - 55px);
      display: inline-block;
      vertical-align: middle;
      line-height: 1.2;
    }
  }
  .action_list {
      display: flex;
      margin: 0;
      justify-content: flex-end;
      padding-right:3px;
      li {
      margin-left: 10px;
      &:first-child{margin-left:0px;}
      .btn {
      padding: 2px 8px;
      }}
  }
  .dctr_slctd_cat{
    span{
        background: #261139;
        padding: 1px 12px 2px;
        line-height: 1;
        border-radius: 20px;
        font-size: 16px;
        color: #a560e8;
        text-transform:capitalize;
    }
}
}
.coming_soon {
    color: #fff;
    padding: 10px;
    font-size: 20px;
    font-family: MyriadProRegular, Lato, sans-serif;
    transition: all .5s ease;
    -webkit-transition: all .5s ease;
    -moz-transition: all ease .5s;
    border-top: 0;
    background: rgba(228, 233, 237, .1);
    margin-top: 5px;
}
</style>